module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "sc-faq-link",
    on: {
      "click": function($event) {
        return _vm.toggleFaq()
      }
    }
  }, [_c('span', [_vm._v("Questions?")]), _vm._v(" Read the FAQ\n    "), _c('img', {
    attrs: {
      "src": (_vm.scBaseUrl + "/assets/images/info.svg"),
      "alt": "faq"
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "fadeIn",
      "leave-active-class": "fadeOut",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFaq),
      expression: "showFaq"
    }],
    staticClass: "sc-faq-box",
    class: _vm.showFaq ? 'sc-faq-box-overlay' : '',
    style: (("display: block;z-index:" + (_vm.highestZIndex + 18)))
  }, [_c('div', {
    key: "faq_box"
  }, [_c('div', {
    staticClass: "faq-header"
  }, [_vm._v(_vm._s(_vm.faq.title))]), _vm._v(" "), _c('div', {
    staticClass: "faq-content",
    domProps: {
      "innerHTML": _vm._s(_vm.faq.description)
    }
  })]), _vm._v(" "), _c('div', {
    key: "faq_close",
    staticClass: "faq-close faq-close-action",
    class: {
      rotateCenter: _vm.showFaq
    },
    on: {
      "click": function($event) {
        return _vm.toggleFaq()
      }
    }
  }, [_c('span')])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17c05133"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaqComponent.vue
// module id = 106
// module chunks = 0